import * as type from './types';

export function updateProfile(data) {
    return {
        type: type.POST_UPDATE_PROFILE_REQUESTED,
        data: data,
    }
}